import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export function gtmInterceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);
  return next(req).pipe(
    switchMap((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const body: any = event.body;
        if (body?.Head?.GTM) {
          from(import('./gtm.handler')).pipe(
            switchMap(
              (m: {
                handleGtmInterceptorEvent: (
                  event: HttpEvent<unknown>,
                  gtm: object,
                  injector: Injector
                ) => Observable<HttpEvent<unknown>>;
              }) => m.handleGtmInterceptorEvent(event, body?.Head?.GTM, injector)
            )
          );
        }
      }

      return of(event);
    })
  );
}
